// extracted by mini-css-extract-plugin
module.exports = {"section":"Top_section__3dMXT","container":"Top_container__39zqn","introduction":"Top_introduction__2v4xB"};